module.exports = __webpack_public_path__ + "img/bl.0b8158f1.svg";